<template>
  <v-bottom-sheet v-model="dialog" max-height="85%" :min-height="`${minHeight}%`" content-class="!rounded-t-[16px] bg-white">
    <div class="max-h-screen bg-white px-5 pb-[20px] pt-3 !rounded-t-[16px] overflow-y-auto no-scrollbar overscroll-none" :class="customClass">
      <div class="h-1 w-8 bg-[#DADEE3] mx-auto rounded mb-4"></div>
      <slot />
    </div>
  </v-bottom-sheet>
</template>

<script lang="ts" setup>
import { computed } from "vue";
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  customClass: {
    type: String,
    default: "",
  },
  minHeight: {
    type: Number,
    default: 20,
  },
});

const emit = defineEmits(["update:modelValue"]);

const dialog = computed({
  get() {
    return props.modelValue;
  },
  set(value: boolean) {
    emit("update:modelValue", value);
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-btn) {
  height: 48px !important;
}
</style>
